module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10225.c8653b94.jpg";